import { AdminNavItem } from '../models/interfaces/admin-nav.interface';

export const ADMIN_NAV_ITEMS: readonly AdminNavItem[] = [
    {
        labelKey: 'admin.nav.clients',
        icon: 'person_outline',
        link: '/admin/clientes',
    },
];
